// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p5-1";
export var messageSideRight = "_p5-2";
export var orderLookupBubbleContainer = "_p5-0";
export var submitButton = "_p5-3";